import { composeSchema, createMarkdownRteEditor, propertyBuilder } from '@refract-cms/core';
import Icon from '@material-ui/icons/Info';
import { FileSystemImageSchema } from '../plugins/file-system-image';

export const AboutSchema = composeSchema({
  options: {
    alias: 'about',
    displayName: 'About',
    icon: Icon,
    maxOne: true,
    mongoCollectionName: 'about',
  },
  properties: {
    aboutText: {
      type: String,
      displayName: 'About text',
      editorComponent: createMarkdownRteEditor(),
    },
    // bookImage: propertyBuilder.singleSchemaPicker(FileSystemImageSchema, {
    //   displayName: 'Book image',
    // }),
  },
});
